import { createFetchedDataRecord, updateObject } from '@vista-digital/utilities';
import { wrapInArray } from '../../../../../utils/array-utils';
import { browsingDomainStore } from '../../../store';
export const assignFilmListRelatedData = (relatedData, cacheDuration) => {
    const { castAndCrew, censorRatings, genres, events } = relatedData;
    const state = browsingDomainStore.data;
    updateObject(state.castAndCrewMembersById, createFetchedDataRecord(castAndCrew, 'id', cacheDuration));
    updateObject(state.censorRatingsById, createFetchedDataRecord(censorRatings, 'id', cacheDuration));
    updateObject(state.genresById, createFetchedDataRecord(genres, 'id', cacheDuration));
    updateObject(state.eventsById, createFetchedDataRecord(events, 'id', cacheDuration));
};
export const assignFilmRelatedData = (relatedData, cacheDuration) => {
    const filmListRelatedData = Object.assign(Object.assign({}, relatedData), { censorRatings: wrapInArray(relatedData.censorRating), events: wrapInArray(relatedData.event) });
    assignFilmListRelatedData(filmListRelatedData, cacheDuration);
};
export const assignFilmAvailabilityRelatedData = (relatedData, cacheDuration) => {
    const { attributes } = relatedData;
    const state = browsingDomainStore.data;
    updateObject(state.attributesById, createFetchedDataRecord(attributes, 'id', cacheDuration));
};
//# sourceMappingURL=assign-related-data.js.map